import {
  Sony_P,
  AaronSChristo,
  AdithyanAS,
  AlnaRebeccaSiby,
  AmrithP,
  ArjunSPai,
  DanylThomas,
  DijithDinesh,
  EvanPaulGibi,
  JoeGeorge,
  SSreeshankar,
  NiranjanaA,
} from "../../assets/team/teamImages";

export const year = "2026-27";
export const isCurrent = true;

export const coreSlices = [
  [0, 3],
  [3, 7],
  [7, 12],
];

export const core = [
  {
    id: 1,
    name: "Dr. Sony P",
    title: "Faculty Advisor",
    image: Sony_P,
    linkedIn: "",
  },
  {
    id: 2,
    name: "Arjun S Pai",
    title: "Chairperson",
    image: ArjunSPai,
    linkedIn: "",
  },
  {
    id: 3,
    name: "Danyl Thomas",
    title: "Vice-Chairperson",
    image: DanylThomas,
    linkedIn: "",
  },
  {
    id: 4,
    name: "Dijith Dinesh",
    title: "CP Lead",
    image: DijithDinesh,
    linkedIn: "",
  },
  {
    id: 5,
    name: "Aaron S Christo",
    title: "Events Lead",
    image: AaronSChristo,
    linkedIn: "",
  },
  {
    id: 6,
    name: "Alna Rebecca Siby",
    title: "Publicity Lead",
    image: AlnaRebeccaSiby,
    linkedIn: "",
  },
  {
    id: 7,
    name: "Amrith P",
    title: "Media Lead",
    image: AmrithP,
    linkedIn: "",
  },
  {
    id: 8,
    name: "Evan Paul Gibi",
    title: "Community Lead",
    image: EvanPaulGibi,
    linkedIn: "",
  },
  {
    id: 9,
    name: "S Sreeshankar",
    title: "Content Lead",
    image: SSreeshankar,
    linkedIn: "",
  },
  {
    id: 10,
    name: "Niranjana A",
    title: "Design Lead",
    image: NiranjanaA,
    linkedIn: "",
  },
  {
    id: 11,
    name: "Adithyan A S",
    title: "Executive",
    image: AdithyanAS,
    linkedIn: "",
  },
  {
    id: 12,
    name: "Joe George",
    title: "Executive",
    image: JoeGeorge,
    linkedIn: "",
  },
];

export const teams = [
  {
    name: "Competitive Programming",
    members: [
      { name: "Jiya Mary Jacob" },
      { name: "Diya Dini" },
      { name: "K Adhil Ahmed" },
      { name: "Joel N George" },
      { name: "John Thomas Mathew" },
    ],
  },
  {
    name: "Media Team",
    members: [
      { name: "Neehara Anna Bince" },
      { name: "Hanna Fathima" },
      { name: "Sreeshant Raju" },
    ],
  },
  {
    name: "Content Team",
    members: [
      { name: "Krishna D Nair" },
      { name: "Anirudh Kuttikkattil" },
    ],
  },
  {
    name: "Design Team",
    members: [{ name: "Adwaith M" }, { name: "Meenakshi B J" }],
  },
  {
    name: "Publicity Team",
    members: [{ name: "Zana Fathima" }],
  },
  {
    name: "Events Team",
    members: [
      { name: "Aniketh Prasanth" },
      { name: "Melath Gopika Krishna" },
      { name: "Karthik Chandrasekharan Iyer" },
      { name: "Arya K A" },
    ],
  },
];
